import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { creatRepositoriesPageAddRepositoryModalOptions } from 'modals/modal-options-factory';
import {
  getMessages,
  markMessagesAsRead,
  removeMessages
} from 'common/services/message-center.service';
import { createModalWrapper } from '../../../views/root/views/home/views/settings/views/RepositoriesV2/repositoriesSections';
import {
  getSuccessSnackbarTitle,
  processingRepos
} from '../../../views/root/views/home/views/settings/views/RepositoriesV2/repositories.service';
import { debouncedToggleSnackBar } from 'common/utils/utils';
import { PROVIDERS_FETCH_LARGE_REPOS_FF } from 'common/constants/constants';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';

const openRepositoriesModal = async ({
  newRepositories = [],
  dedup_key,
  sensor_authorization_id,
  gitIntegrations,
  createRepositories,
  setIsProcessingRepos,
  toggleModal,
  toggleSnackBar,
  setAnchorEl,
  applyAndFetch,
  getSettingOrDefinitionValue,
  getRepositories
}) => {
  const name = _.get(
    _.find(gitIntegrations, ({ id }) => id === sensor_authorization_id),
    'name',
    'Edit Repositories'
  );

  const sensorName = _.get(
    _.find(gitIntegrations, ({ id }) => id === sensor_authorization_id),
    'sensor_name'
  );

  const isFetchLargeRepos = getSettingOrDefinitionValue({
    name: _.get(PROVIDERS_FETCH_LARGE_REPOS_FF, [sensorName])
  });

  const isGithubFetchAllRepoTypesFF = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.githubFetchAllRepoTypes
  });

  setAnchorEl({});

  toggleModal(
    creatRepositoriesPageAddRepositoryModalOptions(
      {
        createRepositories,
        toggleModal,
        hideDots: true,
        hideBackdrop: false,
        hideLogo: true,
        newRepositories,
        ...(sensor_authorization_id ? { sensor_authorization_id } : {}),
        onSubmitCb: async ({ repositories, isV2 = false }) => {
          try {
            // TODO: handle after repositories save handler
            processingRepos({
              getRepositories,
              setIsProcessingRepos
            });

            debouncedToggleSnackBar(
              isV2
                ? 'Repositories added successfully.'
                : getSuccessSnackbarTitle(repositories),
              'NOTE: It might take couple of hours to see updated data reflecting this change.',
              true,
              toggleSnackBar
            );
          } catch (e) {
            debouncedToggleSnackBar(
              `Failed to add repositories`,
              '',
              false,
              toggleSnackBar
            );
          }
          toggleModal();
        },
        onRemoveMessage: async () => {
          await applyAndFetch(removeMessages, dedup_key);
        },
        isFetchLargeRepos,
        isGithubFetchAllRepoTypesFF
      },
      {
        ContentWrapper: createModalWrapper(name, toggleModal),
        showCloseButton: false
      }
    )
  );
};

const addRepositories = async ({
  newRepositories = [],
  dedup_key,
  createRepositories,
  setIsProcessingRepos,
  toggleSnackBar,
  setAnchorEl,
  getRepositories
}) => {
  try {
    await createRepositories(newRepositories);
    await removeMessages(dedup_key);

    processingRepos({
      setIsProcessingRepos,
      getRepositories
    });
    debouncedToggleSnackBar(
      getSuccessSnackbarTitle(newRepositories),
      'NOTE: It might take couple of hours to see updated data reflecting this change.',
      true,
      toggleSnackBar
    );
  } catch (error) {
    debouncedToggleSnackBar(
      `Failed to add repositories`,
      '',
      false,
      toggleSnackBar
    );
  }
  setAnchorEl({});
};

const withMessageCenterData = WrappedComponent => props => {
  const [anchorEl, setAnchorEl] = useState({});
  const [messages, setMessages] = useState([]);
  const [disableMessagesCenter, setDisableMessagesCenter] = useState(false);

  const applyAndFetch = async (applyFunc, params) => {
    setDisableMessagesCenter(true);
    await applyFunc(params);
    await fetchMessages();
    setDisableMessagesCenter(false);
  };

  const fetchMessages = async () => {
    const fetchedMessages = await getMessages();
    setMessages(fetchedMessages);
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  return (
    <WrappedComponent
      {...props}
      messages={messages}
      disableMessagesCenter={disableMessagesCenter}
      markMessagesAsRead={markMessagesAsRead}
      removeMessages={removeMessages}
      applyAndFetch={applyAndFetch}
      anchorEl={anchorEl}
      setAnchorEl={setAnchorEl}
      addRepositories={addRepositories}
      openRepositoriesModal={openRepositoriesModal}
    />
  );
};

export default withMessageCenterData;
